import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Form,
  FormControl
} from 'react-bootstrap';
import Flex from 'components/common/Flex';
import StandardInfoMgmtModal from 'components/pages/haccp/inspStandardInfo/standardInfoMgmt/modal/standardInfoMgmtModal';
import standardInfo from 'components/pages/haccp/inspStandardInfo/standardInfoMgmt/column/standardInfo';
import templateInfo from 'components/pages/haccp/inspStandardInfo/standardInfoMgmt/column/templateInfo';

// global
import { useConfirmModalState } from 'global/confirmModalState';
// types
import { DISABLE_TYPE, ACTION_TYPE } from 'types/type';
import { RESPONSE_CODE } from 'types/const';
// function
import { getLoginInform } from 'function/login';
import { datas2SfshExcelJSON } from 'function/convert';
import { utils, writeFile } from 'xlsx';

// api
import {
  standardInfoCreate,
  standardInfoDetail,
  standardInfoUpdate
} from 'api/haccp/inspStandardInfo/standardInfoMgmtApi';
import {
  factory,
  category,
  category1,
  category2,
  category3
} from 'api/haccp/commonApi';

/**
 * @description 시료정보관리(기존 검사기준정보 관리) 상세페이지
 */

const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { state } = useLocation();
  const { seq } = useParams();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [adminYn, setAdminYn] = useState(null); // 'Y': 관리자, N: 이천,군산 담당자
  const [action, setAction] = useState('');
  const [actionType, setActionType] = useState('');
  const [validated, setValidated] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [factoryOptions, setFactoryOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState(null);
  const [category1Options, setCategory1Options] = useState(null);
  const [category2Options, setCategory2Options] = useState(null);
  const [category3Options, setCategory3Options] = useState(null);

  // 시료정보관리 및 시료정보설정
  const [inspStdInfo, setInspStdInfo] = useState({
    inspStanNm: null, // 검사기준정보명
    ctgryGrpCd: null, // 분류
    pltCd: null, // 공장
    useYn: 'Y',
    description: null, // 비고
    ctgry1Cd: null, // 대분류
    ctgry2Cd: null, // 중분류
    ctgry3Cd: null, // 소분류
    productGroup: null, // 제품군
    isDisabled: false
  });

  // 시료기준관리(성분별 템플릿) 정보 상세 목록
  const [inspStdInfoDetail, setInspStdInfoDetail] = useState([]);
  // 시료기준관리(성분별 템플릿) 정보
  const [inspStdInfoList, setInspStdInfoList] = useState([]);
  // 시료기준관리(성분별 템플릿) 정보 원본데이터
  const [inspStdInfoListOrigin, setInspStdInfoListOrigin] = useState([]);

  // 등록성분량
  const [registIrdntList, setRegistIrdntList] = useState([]);

  // 분류 선택에 따른 대분류, 중분류, 소분류 Title변경
  const [category1Title, setCategory1Title] = useState(null);
  const [category2Title, setCategory2Title] = useState(null);
  const [category3Title, setCategory3Title] = useState(null);

  // event

  /**
   * 공장선택
   */
  const onFactory = e => {
    const { value } = e.target || {};

    if (value !== null && inspStdInfoDetail.length > 0) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message:
          '공장 변경시 기존선택 된 정보가 초기화됩니다. \n 변경하시겠습니까?',
        isConfirmBtn: true,
        isCancelBtn: true,
        onConfirm: () => {
          setInspStdInfo({
            ...inspStdInfo,
            pltCd: value,
            ctgryGrpCd: null,
            ctgry1Cd: null,
            ctgry2Cd: null,
            ctgry3Cd: null
          });

          // 검사성분 mapping Data 초기화
          setInspStdInfoList([]);
          // 시료기준관리(성분별 템플릿) 정보 초기화
          setInspStdInfoDetail([]);
        }
      });
      return;
    }

    setInspStdInfo({
      ...inspStdInfo,
      pltCd: value,
      ctgryGrpCd: null,
      ctgry1Cd: null,
      ctgry2Cd: null,
      ctgry3Cd: null
    });
  };

  /**
   *  분류선택
   *  제품,원료 : 대분류, 중분류, 소분류 3Deps
   *  공정: 대분류, 중분류 2Deps
   */
  const onCategory = async e => {
    const { value } = e.target || {};

    if (value !== null && inspStdInfoDetail.length > 0) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message:
          '분류변경 시 시료기준관리(성분별 템플릿) 정보가 초기화됩니다. \n 변경하시겠습니까?',
        isConfirmBtn: true,
        isCancelBtn: true,
        onConfirm: () => {
          onReset(value);
        }
      });
      return;
    }

    // 분류 선택에 따른 대,중,소분류 타이틀 변경
    categoryTitle(value);

    // 대,중,소분류 초기화
    setInspStdInfo({
      ...inspStdInfo,
      ctgryGrpCd: value,
      ctgry1Cd: null,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    // 공정 대분류 API 호출
    if (value === 'proc') {
      onProcess(value);
      return;
    }

    // 제품,원료 대분류 API 호출
    const params = {
      ctgryGrpCd: value
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCategory1Options(list);
    setCategory2Options([]);
    setCategory3Options([]);
  };

  /**
   * 분류 > 공정선택(대분류) API호출
   */
  const onProcess = async value => {
    const factorySeq = factoryOptions?.find(
      e => e.pltCd === inspStdInfo.pltCd
    )?.seq;

    const params = {
      ctgryGrpCd: value,
      pltCd: inspStdInfo.pltCd,
      pltCdSeq: factorySeq
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCategory1Options(list);
    setCategory2Options([]);
    setCategory3Options([]);
    return;
  };

  /**
   * 분류 변경 시 기존등록 된 DATA 초기화
   */
  const onReset = async value => {
    // 분류 선택에 따른 대,중,소분류 타이틀 변경
    categoryTitle(value);

    // 대,중,소분류 초기화
    setInspStdInfo({
      ...inspStdInfo,
      ctgryGrpCd: value,
      ctgry1Cd: null,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    // 검사성분 mapping 정보 초기화
    setInspStdInfoList([]);
    // 시료기준관리(성분별 템플릿) 정보 초기화
    setInspStdInfoDetail([]);

    // 분류 -> 공정선택 시  중분류 API호출
    if (value === 'proc') {
      onProcess(value);
      return;
    }

    // 분류 -> 제품,원료 시 대분류 API호출
    const params = {
      ctgryGrpCd: value
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCategory1Options(list);
    setCategory2Options([]);
    setCategory3Options([]);
  };

  /**
   * 대분류 선택시  > 중분류 API호출
   */
  const onCategory1 = async e => {
    const { value } = e.target || {};

    setInspStdInfo({
      ...inspStdInfo,
      ctgry1Cd: value,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    const factorySeq = factoryOptions?.find(
      e => e.pltCd === inspStdInfo.pltCd
    )?.seq;

    // 중분류 API호출
    const params = {
      ctgryGrpCd: inspStdInfo.ctgryGrpCd,
      ctgry1Cd: value,
      pltCd: inspStdInfo.pltCd,
      pltCdSeq: factorySeq
    };

    const response = await category2(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setCategory2Options(list);
  };

  /**
   * 중분류 선택시  > 소분류 API호출
   */
  const onCategory2 = async e => {
    const { value } = e.target || {};

    setInspStdInfo({
      ...inspStdInfo,
      ctgry2Cd: value,
      ctgry3Cd: null
    });

    // 공정인 경우 소분류  API호출 X
    if (inspStdInfo.ctgryGrpCd === 'proc') return;

    // 제품,원료인 경우 소분류 API호출
    const factorySeq = factoryOptions?.find(
      e => e.pltCd === inspStdInfo.pltCd
    )?.seq;

    const params = {
      ctgryGrpCd: inspStdInfo.ctgryGrpCd,
      ctgry2Cd: value,
      pltCd: inspStdInfo.pltCd,
      pltCdSeq: factorySeq
    };

    // 소분류 API호출
    const response = await category3(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setCategory3Options(list);
  };

  /**
   * 목록페이지 이동
   */
  const onList = () => {
    history.push({
      pathname: '/haccp/inspectionInfo',
      state: state
    });
  };

  /**
   * 검사그룹 페이지 이동
   */
  const onGroupPage = () => {
    history.push({
      pathname: '/haccp/inspectionGroup'
    });
  };

  /**
   * Modal Open
   */
  const onModalOpen = () => {
    if (inspStdInfo.ctgryGrpCd === null) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '분류를 먼저 선택해주세요.',
        isConfirmBtn: true
      });

      return;
    }

    setModalShow(true);
  };

  /**
   * 모달 검사항목 선택완료
   */
  const modalConfirm = value => {
    // 기존선택 검사항목 및 신규선택 검사항목
    const arrDup = [
      ...value,
      ...inspStdInfoList?.filter(e => e.isCheck === true)
    ];

    // array 중복제거
    const arrUnique = arrDup.filter((data, index, array) => {
      return (
        array.findIndex(item => item.mappingSeq === data.mappingSeq) === index
      );
    });

    /**
     * 검사항목 기존, 신규 Data Mapping
     * 신규등록 histType = C
     * 기존등록 histType = U
     */
    arrUnique?.map((e, index) => {
      e.no = index + 1;
      // 신규등록된 시료기준관리(성분별 템플릿) 정보
      e.histType = 'C';
      e.inspStanSeq = Number(seq);
      e.inspIrdntGroupSeq = e.seq;
      // 기존등록된 시료기준관리(성분별 템플릿) 정보
      inspStdInfoListOrigin?.forEach(data => {
        if (e.mappingSeq === data.inspIrdntGroupSeq) {
          e.histType = 'U';
          e.seq = data.seq;
          e.inspStanSeq = data.inspStanSeq;
          e.inspIrdntGroupSeq = data.inspIrdntGroupSeq;
        }
      });
      return e;
    });

    setInspStdInfoList(arrUnique);

    // 시료기준관리(성분별 템플릿)정보 Mapping정보 추가
    let array = [];
    for (const value of arrUnique) {
      const { inspIrdntGrpLimitList = [] } = value || {};

      const data = inspIrdntGrpLimitList.map(e => {
        return {
          ...e,
          seq: value.seq,
          mappingSeq: value.inspIrdntGrpSeq,
          inspIrdntGrpNm: value.inspIrdntGrpNm,
          inspIrdntGroupSeq: value.inspIrdntGroupSeq
        };
      });

      array = [...array, ...data];
    }

    setInspStdInfoDetail(array);
    setModalShow(false);
  };

  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (inspStdInfoList.length === 0) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '시료기준관리(성분별 템플릿) 정보 등록해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `시료정보를 ${action}하시겠습니까?`,
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        onSubmit();
      }
    });
  };

  const onSubmit = async () => {
    const {
      pltCd,
      inspStanNm,
      ctgryGrpCd,
      ctgry1Cd,
      ctgry2Cd,
      ctgry3Cd,
      useYn,
      description
    } = inspStdInfo || {};

    let requestBody = {};
    let response = {};

    // 시료기준관리(성분별 템플릿)정보 중복제거
    const arrUnique = inspStdInfoList?.filter((data, index, array) => {
      return array?.findIndex(item => data.seq === item.seq) === index;
    });

    if (DISABLE_TYPE[actionType] === false) {
      // 등록
      requestBody = {
        pltCd: pltCd,
        inspStanNm: inspStanNm,
        ctgryGrpCd: ctgryGrpCd,
        ctgry1Cd: ctgry1Cd,
        ctgry2Cd: ctgry2Cd,
        ctgry3Cd: ctgry3Cd,
        useYn: useYn,
        description: description,
        inspStdIrdntGrpMapList: arrUnique?.map(e => ({
          inspIrdntGroupSeq: e.seq
        }))
      };
      response = await standardInfoCreate(requestBody);
    } else {
      // 수정
      requestBody = {
        pltCd: pltCd,
        inspStanNm: inspStanNm,
        ctgryGrpCd: ctgryGrpCd,
        ctgry1Cd: ctgry1Cd,
        ctgry2Cd: ctgry2Cd,
        ctgry3Cd: ctgry3Cd,
        useYn: useYn,
        description: description,
        inspStdIrdntGrpMapList: arrUnique?.map(e => ({
          seq: e.histType === 'C' ? null : e.seq,
          inspStanSeq: Number(seq),
          inspIrdntGroupSeq: inspStdInfoList?.find(
            data => data.mappingSeq === e.mappingSeq
          )?.inspIrdntGroupSeq,
          histType: inspStdInfoListOrigin?.some(
            data => data.inspIrdntGroupSeq === e.mappingSeq
          )
            ? 'U'
            : 'C',
          delYn: 'N'
        }))
      };
      response = await standardInfoUpdate(seq, requestBody);
    }

    const { code, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `시료정보관리가 정상 ${action} 되었습니다.`,
      isConfirmBtn: true
    });

    // 등록일 경우만 조회조건 초기화 및 sort조건 변경
    if (actionType === 'create') {
      history.push({
        pathname: '/haccp/inspectionInfo',
        state: {
          ...state,
          pltCd: adminYn === 'Y' ? '' : pltCd,
          ctgryGrpCd: '',
          useYn: '',
          inspStanNm: '',
          page: 0,
          sort: 'seq,desc'
        }
      });
      return;
    }

    onList();
  };

  /**
   * 엑셀다운로드
   */
  const onExcelDown = () => {
    // gap rows
    function create_gap_rows(ws, nrows) {
      let ref = utils.decode_range(ws['!ref']); // get original range
      ref.e.r += nrows; // add to ending row
      ws['!ref'] = utils.encode_range(ref); // reassign row
    }

    let array = [];
    array.push(inspStdInfo);

    const headers = ['검사 기본 정보', '시료기준관리 정보'];

    let obj = standardInfo;
    obj = {
      ...obj,
      ctgry1Nm: category1Title || '',
      ctgry2Nm: category2Title || '',
      ctgry3Nm: category3Title || ''
    };
    const firstExcelData = datas2SfshExcelJSON(array, obj);

    /* first data */
    // const ws = utils.aoa_to_sheet([[headers[0]]]);
    const worksheet = utils.sheet_add_json(worksheet, firstExcelData, {
      origin: -1
    });
    create_gap_rows(worksheet, 1); // one row gap after first table

    /* second data*/
    const secondExcelData = datas2SfshExcelJSON(
      inspStdInfoDetail?.map(e => {
        e.inspLimitMthCd = limitStandard(
          e.inspLimitMthCd,
          e.inspLimitMin,
          e.inspLimitMax
        );
        return e;
      }),
      templateInfo
    );
    // utils.sheet_add_aoa(ws, [[headers[1]]], { origin: -1 });
    utils.sheet_add_json(worksheet, secondExcelData, { origin: -1 });
    create_gap_rows(worksheet, 2);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, worksheet);
    writeFile(wb, '시료기준관리(성분별 템플릿) 정보.xlsx');
  };

  /* method */
  const limitStandard = (limitStdCd, min, max) => {
    let value = '';

    switch (limitStdCd) {
      case 'mth_mm':
        // min/max
        value = `${min}/${max}`;
        break;
      case 'mth_min':
        // min
        value = `${min}이상`;
        break;
      case 'mth_max':
        // max
        value = `${max}이하`;
        break;
      case 'mth_dtc':
        // max
        value = '불검출';
        break;
    }

    return value;
  };

  /**
   * 분류선택에 따른 검사정보설정 대,중,소분류 타이틀 변경
   */
  const categoryTitle = ctgryGrpCd => {
    switch (ctgryGrpCd) {
      case 'prdt':
        // 제품
        setCategory1Title('축종');
        setCategory2Title('등록명칭');
        setCategory3Title('등록명칭번호');
        break;
      case 'proc':
        // 공정
        setCategory1Title('공정명');
        setCategory2Title('의뢰명');
        setCategory3Title('');
        break;
      case 'rwmtr':
        // 원료
        setCategory1Title('자재번호');
        setCategory2Title('외부자재번호');
        setCategory3Title('원료명');
        break;
    }
  };

  /**
   * 상세 API
   */
  const onDetail = async () => {
    /*상세 API호출*/
    const response = await standardInfoDetail(seq);

    const { code, data, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const {
      inspStanNm,
      pltCd,
      pltNm,
      ctgryGrpCd,
      ctgryGrpNm,
      description,
      useYn,
      ctgry1Cd,
      ctgry1Nm,
      ctgry2Cd,
      ctgry2Nm,
      ctgry3Cd,
      ctgry3Nm,
      productGroup = null,
      inspStdIrdntGrpMapList,
      registIrdntList
    } = data || {};

    // 분류 선택에 따른 대,중,소분류 타이틀 변경
    categoryTitle(ctgryGrpCd);

    setInspStdInfo({
      ...inspStdInfo,
      inspStanNm: inspStanNm, // 검사정보명
      pltCd: pltCd, // 공장
      pltNm: pltNm,
      ctgryGrpCd: ctgryGrpCd, // 분류
      ctgryGrpNm: ctgryGrpNm,
      description: description, // 비고
      useYn: useYn, // 사용유무
      ctgry1Cd: ctgry1Cd,
      ctgry1Nm: ctgry1Nm,
      ctgry2Cd: ctgry2Cd,
      ctgry2Nm: ctgry2Nm,
      ctgry3Cd: ctgry3Cd,
      ctgry3Nm: ctgry3Nm,
      productGroup: productGroup, // 제품군
      isDisabled: true
    });

    // 기존등록된 시료기준관리(성분별 템플릿) 정보
    setInspStdInfoList(
      inspStdIrdntGrpMapList?.map((e, index) => ({
        no: index + 1,
        mappingSeq: e.inspIrdntGroupSeq,
        isCheck: true,
        ...e
      })) ?? []
    );

    // 시료기준관리(성분별 템플릿) 정보 원본
    setInspStdInfoListOrigin(inspStdIrdntGrpMapList);

    // 등록성분량
    setRegistIrdntList(registIrdntList);

    // 시료기준관리(성분별 템플릿)정보 Mapping정보 추가
    let array = [];
    for (const value of inspStdIrdntGrpMapList) {
      const { inspIrdntGrpLimitList = [] } = value || {};

      const data = inspIrdntGrpLimitList.map(e => {
        return {
          ...e,
          seq: value.seq,
          mappingSeq: value.inspIrdntGrpSeq,
          inspIrdntGrpNm: value.inspIrdntGrpNm,
          inspIrdntGroupSeq: value.inspIrdntGroupSeq
        };
      });

      array = [...array, ...data];
    }

    setInspStdInfoDetail(array);
  };

  /**
   * 공장목록 API
   */
  const factoryList = async () => {
    const response = await factory();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setFactoryOptions(list);
  };

  /**
   * 분류목록 API
   */
  const categoryList = async () => {
    const response = await category();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setCategoryOptions(list);
  };

  /**
   * 로그인 정보
   */
  const loginInfo = () => {
    const { adminYn, pltCd } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    setInspStdInfo(prevState => ({
      ...prevState,
      pltCd: pltCd
    }));

    setAdminYn(adminYn);
  };

  /* watch */
  useEffect(() => {
    // 공장 API 호출
    factoryList();
    // 분류 API 호출
    categoryList();
    // 로그인 정보
    loginInfo();
  }, []);

  useEffect(() => {
    switch (actionType) {
      case ACTION_TYPE.CREATE: {
        setAction('등록');
        break;
      }
      case ACTION_TYPE.UPDATE: {
        setAction('수정');
        onDetail();
        break;
      }
    }
  }, [actionType]);

  useLayoutEffect(() => {
    if (seq) {
      setActionType('update');
      return;
    }
    setActionType('create');
  }, []);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="g-3 mb-3">
          <Col lg={6}>
            <Card className="h-100">
              <Card.Header>
                <Row className="align-items-center g-2">
                  <Col>
                    <h5 className="mb-0">검사 기본 정보</h5>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="bg-light">
                {/* 검사정보명 */}
                <Form.Group className="mb-3">
                  <Form.Label>*검사정보명</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    size="sm"
                    placeholder="20자 이내로 입력해주세요."
                    maxLength="20"
                    value={inspStdInfo.inspStanNm || ''}
                    onChange={e =>
                      setInspStdInfo({
                        ...inspStdInfo,
                        inspStanNm: e.target.value
                      })
                    }
                    disabled={inspStdInfo.isDisabled === true}
                  />
                </Form.Group>
                {/* 공장 선택 select-box */}
                <Form.Group className="mb-3">
                  <Form.Label>*공장</Form.Label>
                  <Form.Select
                    required
                    size="sm"
                    onChange={e => onFactory(e)}
                    value={inspStdInfo.pltCd || ''}
                    disabled={
                      adminYn === 'N' || inspStdInfo.isDisabled === true
                    }
                  >
                    <option hidden value="">
                      공장선택
                    </option>
                    {factoryOptions?.map(option => (
                      <option key={option.pltCd} value={option.pltCd}>
                        {option.pltNmKo}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {/* 분류 선택 select-box */}
                <Form.Group className="mb-3">
                  <Form.Label>*분류</Form.Label>
                  <Form.Select
                    required
                    size="sm"
                    onChange={e => onCategory(e)}
                    value={inspStdInfo.ctgryGrpCd || ''}
                    disabled={inspStdInfo.isDisabled === true}
                  >
                    <option hidden value="">
                      분류선택
                    </option>
                    {categoryOptions?.map(option => (
                      <option key={option.ctgryCd} value={option.ctgryCd}>
                        {option.ctgryNmKr}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {/* 비고 */}
                <Form.Group className="mb-3">
                  <Form.Label>비고</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    placeholder="30자 이내로 입력해주세요."
                    maxLength="30"
                    value={inspStdInfo.description || ''}
                    onChange={e =>
                      setInspStdInfo({
                        ...inspStdInfo,
                        description: e.target.value
                      })
                    }
                  />
                </Form.Group>
                {/* 사용유무 */}
                <Form.Group className="mb-3">
                  <Form.Label>*사용유무</Form.Label>
                  <Flex>
                    <Form.Check
                      type="radio"
                      id="use"
                      label="사용"
                      name="useYn"
                      value="Y"
                      checked={inspStdInfo.useYn === 'Y'}
                      onChange={e =>
                        setInspStdInfo({
                          ...inspStdInfo,
                          useYn: e.target.value
                        })
                      }
                    />
                    <Form.Check
                      type="radio"
                      id="unuse"
                      label="미사용"
                      className="ms-3"
                      name="useYn"
                      value="N"
                      checked={inspStdInfo.useYn === 'N'}
                      onChange={e =>
                        setInspStdInfo({
                          ...inspStdInfo,
                          useYn: e.target.value
                        })
                      }
                    />
                  </Flex>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={6}>
            <Card className="h-100">
              <Card.Header>
                <Row className="align-items-center g-2">
                  <Col>
                    <h5 className="mb-0">검사 정보 설정</h5>
                  </Col>
                </Row>
              </Card.Header>
              {(inspStdInfo.ctgryGrpCd === null ||
                inspStdInfo.pltCd === null) && (
                <div className="h-100 d-flex align-items-center justify-content-center">
                  공장 및 분류를 선택해주세요.
                </div>
              )}
              {inspStdInfo.ctgryGrpCd !== null &&
                inspStdInfo.pltCd !== null && (
                  <Card.Body className="bg-light">
                    {/* 대분류 */}
                    <Form.Group className="mb-3">
                      {inspStdInfo.isDisabled === false && (
                        <>
                          <Form.Label>*{category1Title}</Form.Label>
                          <Form.Select
                            required
                            size="sm"
                            onChange={e => onCategory1(e)}
                            value={inspStdInfo.ctgry1Cd || ''}
                          >
                            <option hidden value="">
                              {category1Title}선택
                            </option>
                            {category1Options?.map((option, index) => (
                              <option key={index} value={option.ctgry1Cd}>
                                {option.ctgry1Nm}
                              </option>
                            ))}
                          </Form.Select>
                        </>
                      )}
                      {inspStdInfo.isDisabled === true && (
                        <>
                          <Form.Label>*{category1Title}</Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            value={inspStdInfo.ctgry1Nm || ''}
                            disabled={inspStdInfo.isDisabled}
                          />
                        </>
                      )}
                    </Form.Group>
                    {/* 중분류 */}
                    <Form.Group className="mb-3">
                      <Form.Label>*{category2Title}</Form.Label>
                      {inspStdInfo.isDisabled === false && (
                        <Form.Select
                          required
                          size="sm"
                          onChange={e => onCategory2(e)}
                          value={inspStdInfo.ctgry2Cd || ''}
                        >
                          <option hidden value="">
                            {category2Title}선택
                          </option>
                          {category2Options?.map(option => (
                            <option
                              key={option.ctgry2Cd}
                              value={option.ctgry2Cd}
                            >
                              {option.ctgry2Nm}
                            </option>
                          ))}
                        </Form.Select>
                      )}
                      {inspStdInfo.isDisabled === true && (
                        <Form.Control
                          type="text"
                          size="sm"
                          value={inspStdInfo.ctgry2Nm || ''}
                          disabled={inspStdInfo.isDisabled}
                        />
                      )}
                    </Form.Group>
                    {/* 소분류 */}
                    {inspStdInfo.ctgryGrpCd !== 'proc' && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>*{category3Title}</Form.Label>
                          {inspStdInfo.isDisabled === false && (
                            <Form.Select
                              required
                              size="sm"
                              onChange={e =>
                                setInspStdInfo({
                                  ...inspStdInfo,
                                  ctgry3Cd: e.target.value
                                })
                              }
                              value={inspStdInfo.ctgry3Cd || ''}
                            >
                              <option hidden value="">
                                {category3Title}선택
                              </option>
                              {category3Options?.map(option => (
                                <option
                                  key={option.ctgry3Cd}
                                  value={option.ctgry3Cd}
                                >
                                  {option.ctgry3Nm}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                          {inspStdInfo.isDisabled === true && (
                            <Form.Control
                              type="text"
                              size="sm"
                              value={inspStdInfo.ctgry3Nm || ''}
                              disabled={inspStdInfo.isDisabled}
                            />
                          )}
                        </Form.Group>
                      </>
                    )}
                    {/* 제품군 */}
                    {inspStdInfo.productGroup !== null && (
                      <Form.Group className="mb-3">
                        <Form.Label>*제품군</Form.Label>
                        <Form.Control
                          as="textarea"
                          size="sm"
                          value={inspStdInfo.productGroup}
                          readOnly
                          className="h-100"
                        />
                      </Form.Group>
                    )}
                  </Card.Body>
                )}
            </Card>
          </Col>
        </Row>
        <Card>
          <Card.Header>
            <Row className="align-items-center g-2">
              <Col>
                <h5 className="mb-0">시료기준관리(성분별 템플릿) 정보</h5>
              </Col>
              <Col xs={'auto'}>
                {actionType === 'create' && (
                  <Button
                    size="sm"
                    className="ms-2"
                    onClick={() => onModalOpen()}
                  >
                    시료기준관리(성분별 템플릿) 선택
                  </Button>
                )}
                {actionType === 'update' && (
                  <>
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={onExcelDown}
                      disabled={inspStdInfoDetail?.length === 0}
                    >
                      엑셀 다운로드
                    </Button>
                    <Button
                      size="sm"
                      className="ms-2"
                      // onClick={() => onModalOpen()}
                      onClick={() => onGroupPage()}
                    >
                      시료기준관리(성분별 템플릿) 수정
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="pt-0">
            <Table responsive bordered className="fs--1 text-center mb-3">
              <thead className="bg-200 text-700 align-middle border-300">
                <tr>
                  <th>No.</th>
                  <th>검사종류</th>
                  <th>의뢰기관</th>
                  <th>검사성분 코드</th>
                  <th>검사결과서 코드</th>
                  <th>템플릿명</th>
                  <th>검사성분명</th>
                  <th>검사방법</th>
                  <th>한계기준값</th>
                  <th>주기</th>
                  <th>CCP관리</th>
                  <th>사용여부</th>
                </tr>
              </thead>
              <tbody>
                {inspStdInfoDetail?.map(
                  (
                    {
                      inspTypeNm,
                      inspLabNm,
                      inspIrdntCd,
                      labInspIrdntCd,
                      inspIrdntGrpNm,
                      inspIrdntNm,
                      inspLimitMthNm,
                      inspLimitMthCd,
                      inspLimitMin,
                      inspLimitMax,
                      cycleNm,
                      ccpYn,
                      useYn
                    },
                    index
                  ) => (
                    <tr
                      key={index}
                      className={useYn === 'N' ? 'table-primary' : ''}
                    >
                      <td>{index + 1}</td>
                      <td>{inspTypeNm}</td>
                      <td>{inspLabNm}</td>
                      <td>{inspIrdntCd}</td>
                      <td>{labInspIrdntCd}</td>
                      <td>{inspIrdntGrpNm}</td>
                      <td>{inspIrdntNm}</td>
                      <td>{inspLimitMthNm}</td>
                      {/* 한계기준값 선택에 따른 구분 */}
                      <td style={{ width: '15%' }}>
                        {/* MIN / MAX 선택 시 */}
                        {inspLimitMthCd === 'mth_mm' && (
                          <Flex alignItems="center">
                            <Form.Control
                              required
                              name="inspLimitMin"
                              type="number"
                              placeholder="하한값"
                              size="sm"
                              value={inspLimitMin ?? ''}
                              disabled={true}
                            />
                            <span className="mx-3">/</span>
                            <Form.Control
                              required
                              name="inspLimitMax"
                              type="number"
                              placeholder="상한값"
                              size="sm"
                              value={inspLimitMax ?? ''}
                              disabled={true}
                            />
                          </Flex>
                        )}
                        {/* MIN 선택 시 */}
                        {inspLimitMthCd === 'mth_min' && (
                          <Flex alignItems="center">
                            {useYn === 'Y' && (
                              <>
                                <Form.Control
                                  required
                                  type="number"
                                  placeholder="값을 입력해주세요."
                                  size="sm"
                                  name="inspLimitMin"
                                  value={inspLimitMin ?? ''}
                                  disabled={true}
                                />
                                <span className="ms-3 flex-grow-1 flex-shrink-0">
                                  이상
                                </span>
                              </>
                            )}
                            {useYn === 'N' && (
                              <>
                                <Form.Control
                                  required
                                  type="number"
                                  placeholder="-"
                                  size="sm"
                                  name="inspLimitMin"
                                  value={inspLimitMin ?? '-'}
                                  disabled={true}
                                />
                                <span className="ms-3 flex-grow-1 flex-shrink-0">
                                  이상
                                </span>
                              </>
                            )}
                          </Flex>
                        )}
                        {/* MAX 선택 시 */}
                        {inspLimitMthCd === 'mth_max' && (
                          <Flex alignItems="center">
                            {useYn === 'Y' && (
                              <>
                                <FormControl
                                  required
                                  type="text"
                                  placeholder="값을 입력해주세요."
                                  size="sm"
                                  name="inspLimitMax"
                                  value={inspLimitMax ?? ''}
                                  disabled={true}
                                />
                                <span className="ms-3 flex-grow-1 flex-shrink-0">
                                  이하
                                </span>
                              </>
                            )}
                            {useYn === 'N' && (
                              <>
                                <FormControl
                                  required
                                  type="text"
                                  placeholder="-"
                                  size="sm"
                                  name="inspLimitMax"
                                  value={inspLimitMax ?? '-'}
                                  disabled={true}
                                />
                                <span className="ms-3 flex-grow-1 flex-shrink-0">
                                  이하
                                </span>
                              </>
                            )}
                          </Flex>
                        )}
                        {/* 검출여부 선택 시 */}
                        {inspLimitMthCd === 'mth_dtc' && (
                          <Form.Control
                            required
                            type="text"
                            size="sm"
                            value={'불검출'}
                            disabled={true}
                          />
                        )}
                        {/* 검출여부 미선택 */}
                        {inspLimitMthCd === null && <span>-</span>}
                      </td>
                      <td>{cycleNm}</td>
                      <td>{ccpYn}</td>
                      <td>{useYn}</td>
                    </tr>
                  )
                )}
                {inspStdInfoDetail?.length < 1 && (
                  <tr>
                    <td colSpan={12} className="w-auto">
                      시료기준관리(성분별 템플릿) 정보 정보가 존재하지 않습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {/* 등록성분량 */}
            {registIrdntList?.length > 0 && (
              <>
                <h5 className="mb-3">등록성분량</h5>
                <Table responsive bordered className="fs--1 text-center mb-0">
                  <thead className="bg-200 text-700 align-middle border-300">
                    <tr>
                      <th>No.</th>
                      <th>항목</th>
                      <th>성분기준치</th>
                      <th>단위</th>
                      <th>비고</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registIrdntList?.map(
                      ({ itemNm, irdntVal, unitNm, description }, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{itemNm}</td>
                          <td>{irdntVal}</td>
                          <td>{unitNm}</td>
                          <td>{description || '-'}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </Card.Body>
          <Card.Footer className="d-flex align-items-center">
            <Button
              size="sm"
              variant="secondary"
              className="ms-auto"
              onClick={() => onList()}
            >
              취소
            </Button>
            <Button size="sm" className="ms-2" type="submit">
              {action}
            </Button>
          </Card.Footer>
        </Card>
      </Form>
      {/*시료기준관리(성분별 템플릿) Modal*/}
      {modalShow === true && (
        <StandardInfoMgmtModal
          modalShow={modalShow}
          setModalShow={setModalShow}
          modalConfirm={modalConfirm}
          itemList={inspStdInfoList}
          setItemList={setInspStdInfoList}
          itemInfo={inspStdInfo}
        ></StandardInfoMgmtModal>
      )}
    </>
  );
};

export default Detail;
